<div class="user-services-stack"
     [class.mobile]="deviceService.isMobile()">
  <div class="title-block">
    <div class="left">
      <span class="title light">{{ 'library.user-services-stack.title' | customLocale }}</span>
      <span class="text normal">{{ 'library.user-services-stack.text' | customLocale }}</span>
    </div>
    <div class="right">
      <on-ui-button class="primary outline"
                    [attr.data-test] = "'user_services_stack_add_button'"
                    *ngIf="!isGuest && isTeacher"
                    label="library.user-services-stack.action"
                    (onclick)="goCreateUserService()">
      </on-ui-button>
    </div>
  </div>
  <hr class="separator">
  <div class="panes">
    <app-pane *ngFor="let pane of panesList; trackBy: trackByFn" [item]="pane"></app-pane>
  </div>
</div>

<ng-template #popoverNotVerified>
  <app-not-verified-widget></app-not-verified-widget>
</ng-template>

<app-modal *ngIf="!deviceService.isMobile() && newService"
           [canClose]="false"
           (closed)="onCancel()">
  <app-modal-body>
    <div class="shade-wrap">
      <ng-template [ngIf]="isAsIfTeacher">
        <span class="text normal" [attr.data-test] = "'user_services_stack_exception'">{{ 'library.user-services-stack.exception' | customLocale }}</span>
        <span class="action normal"
              [appPopover]="popoverNotVerified"
              [position]="position"
              [disabledPopover]="isPopoverNeeded">{{ 'library.user-services-stack.details' | customLocale }}</span>
        <div class="shade"></div>
      </ng-template>
      <app-user-service-form [userService]="newService" (changed)="onChange()"></app-user-service-form>
    </div>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="deviceService.isMobile() && newService"
                  [titleVisible]="false"
                  (closed)="onCancel()">
  <app-mobile-modal-body>
    <div class="shade-wrap-modal">
      <div class="modal-header">
        <div class="title-wrap">
          <h2 class="modal-title bold">{{ 'teacher-profile.new-service' | customLocale }}</h2>
          <div class="close-btn" (click)="onCancel()">
            <app-icon width="20" height="20" icon="close"></app-icon>
          </div>
        </div>

        <ng-template [ngIf]="isAsIfTeacher">
          <span class="text-modal normal" [attr.data-test] = "'user_services_stack_exception'">{{ 'library.user-services-stack.exception' | customLocale }}</span>
          <span class="action-modal normal"
                [appPopover]="popoverNotVerified"
                [position]="position"
                [disabledPopover]="isPopoverNeeded">{{ 'library.user-services-stack.details' | customLocale }}</span>
          <div class="shade-modal"></div>
        </ng-template>
      </div>
      <app-user-service-form [userService]="newService" (changed)="onChange()"></app-user-service-form>
    </div>
  </app-mobile-modal-body>
</app-mobile-modal>
